import React, { ChangeEvent, useState } from 'react';
import './ChatInput.scss';
import images from '../../../../assets/images';

interface ChatInputProps {
    onSend: (text: string) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ onSend }) => {

    const [message, setMessage] = useState<string>('');

    const { Send } = images;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setMessage(event.target.value);
    };

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && message.trim()) {
            onSend(message.trim());
            setMessage('');
        }
    };

    const handleClick = () => {
        if (message.trim()) {
            onSend(message.trim());
            setMessage('');
        }
    };

  return (
    <div className="chat-input">
        <input
            type="text"
            value={message}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="Type something here..."
        />
        <div onClick={handleClick} className='send-icon'>
            <img src={Send} alt='meetChat Icon'/>
        </div>
    </div>
  );
}

export default ChatInput;
